import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';
import { useCart } from '../context/CartContext';
import { Toast, ToastContainer } from 'react-bootstrap';

const ProductCard = ({ product }) => {
  // Placeholder image if product has no image
  const defaultImages = ['1.jpeg', '2.jpeg' , '3.jpeg', '4.jpeg']
  const defaultImage = defaultImages[product?.id % defaultImages.length];
  const { addToCart } = useCart();
  const [showToast, setShowToast] = useState(false);

  const handleAddToCart = () => {
    addToCart(product, 1);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  return (
    <div style={{  background: '#fff',
      borderRadius: 18,
      boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
      padding: 18,
      border: '2px solid #e0e7ff',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      transition: 'transform 0.18s'}}>
      <Link to={`/products/${product.id}`} className="product-image-link">
        <img 
          src={product.image_url || `/images/${defaultImage}`} 
          alt={product.name}
          className="product-image" 
          style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '0.375rem 0.375rem 0 0' }}
        />
      </Link>
      
      <div className="product-info">
        <h3 className="product-title">
          <Link to={`/products/${product.id}`} className="text-decoration-none">
            {product.name}
          </Link>
        </h3>
        
        <p className="product-category">{product.category_name}</p>
        
        <div className="d-flex justify-content-between align-items-center mt-3">
          <span className="product-price">₹{parseFloat(product.price).toFixed(2)}</span>
          <button 
            className="btn btn-primary btn-sm d-flex align-items-center"
            onClick={handleAddToCart}
            style={{ gap: '0.5rem' }}
          >
            <FaShoppingCart /> Add
          </button>
        </div>
        
        {product.stock_quantity < 5 && (
          <p className="text-danger small mt-2">
            Only {product.stock_quantity} left in stock!
          </p>
        )}
      </div>

      <ToastContainer position="bottom-end" className="position-fixed p-3" style={{ zIndex: 1050, bottom: 0, right: 0 }}>
        <Toast show={showToast} onClose={() => setShowToast(false)}>
          <Toast.Header>
            <strong className="me-auto">Added to Cart</strong>
          </Toast.Header>
          <Toast.Body>
            {product.name} added to your cart!
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default ProductCard; 